"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemSetting = require("@/api/systemSetting");
var _toolsValidate = require("@/utils/toolsValidate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'editElectrSheet',
  data: function data() {
    return {
      editDataLocal: {
        id: 0,
        // 编辑时大于0
        cloudPrintNo: "",
        op: 0,
        // 0=通用打印机 1=快递100打印机
        senderAddr: "",
        senderPhone: "",
        senderUsername: ""
      },
      validatePhone: _toolsValidate.validatePhone
    };
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.handledGetElectrInfo();
    },
    handleSubmitClickUp: function handleSubmitClickUp(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.handledEditElectrConfig(_this.editDataLocal);
        } else {
          return false;
        }
      });
    },
    handledEditElectrConfig: function handledEditElectrConfig(param) {
      var _this2 = this;
      (0, _systemSetting.merchantElectrSheetEdit)(param).then(function (data) {
        _this2.$message.success('保存成功');
        _this2.handledGetElectrInfo();
      });
    },
    handledGetElectrInfo: function handledGetElectrInfo() {
      var _this3 = this;
      (0, _systemSetting.merchantElectrSheetInfo)().then(function (data) {
        if (data) {
          _this3.editDataLocal = data;
        }
      });
    }
  }
};